import moment from 'moment'

type PersistedAppStorage = {
  app?: {
    langInfo?: string
  }
}

const raw = localStorage.getItem('CiaoCameraApp')
const localStorageInfo: PersistedAppStorage | null = raw ? JSON.parse(raw) : null
if (localStorageInfo && localStorageInfo.app?.langInfo) {
  moment.locale(localStorageInfo.app.langInfo)
}
